import React, { useState } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
// import Login from './components/login'; 
import Login from './pages/loginpage';
import Queuepage from './pages/queuepage';
import Homepage from './pages/homepage';
import CallLog from './pages/calllogpage';
import Dialpad from './pages/dialpad';
function App() {
  const [loggedInUser, setLoggedInUser] = useState(null);
  const handleLogin = (username) => {
    setLoggedInUser(username);
  };

  return (
    <BrowserRouter >
      <Routes>
        <Route path="/" element={<Login onLogin={handleLogin} />} />
        <Route path="/queuepage" element={<Queuepage />} />
        <Route path="/homepage" element={<Homepage />} />
        <Route path="/dialpadpage" element={<Dialpad />} />
        {/* <Route path="/homepage" element={<Homepage />} />
<Route path="/template" element={<Comtemplete/>} /> */}
      </Routes>
    </BrowserRouter>
  );
}

export default App;